import { IAppState } from 'shared/common/state';

export const selectEarlyAccessContactsFlowEnabled = (state: IAppState) =>
  state.featureToggle.earlyAccessContactsFlowEnabled;
